// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Wishlist Page Container */
.wishlist-page-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 5rem;
}

/* Wishlist Page Title */
.wishlist-page-container .wishlist-page-title {
  font-size: 2.5rem;
  text-align: center;
  color: #247a97;
  margin-top: 4rem;
  margin-bottom: 2rem;
}

/* Wishlist Table */
.wishlist-page-container .wishlist-table {
  width: 100vw;
}

/* Table Header */
.wishlist-page-container .wishlist-table th {
  background-color: #f2f2f2;
  text-align: left;
  padding: 0.5rem 1rem;
}

/* Table Row */
.wishlist-page-container .wishlist-table tr {
  border-bottom: 1px solid #ddd;
}

/* Product Info */
.wishlist-page-container .product-info {
  display: flex;
  align-items: center;
  gap: 1rem;
}

/* Product Avatar */
.wishlist-page-container .product-avatar {
  flex-shrink: 0;
}

/* Product Mask */
.wishlist-page-container .product-mask {
  width: 8rem;
  height: 8rem;
  overflow: hidden;
  border-radius: 50%;
}

.wishlist-page-container .product-mask img {
  width: 100%;
  height: 100%;
  -o-object-fit: cover;
     object-fit: cover;
}

/* Product Name */
.wishlist-page-container .product-name {
  font-size: 1.25rem;
  font-weight: bold;
}

/* Product Material */
.wishlist-page-container .product-material {
  font-size: 0.875rem;
  opacity: 0.7;
}

/* Product Description */
.wishlist-page-container .product-description {
  flex-wrap: wrap;
  text-wrap: wrap;
  width: 50vw;
}

/* Product Category */
.wishlist-page-container .product-category {
  font-size: 0.875rem;
  opacity: 0.7;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* Product Price */
.wishlist-page-container .product-price {
  font-size: 1.25rem;
  font-weight: bold;
}

/* Product Actions */
.wishlist-page-container .product-actions {
  display: flex;
  gap: 0.5rem;
}

/* View Button */
.wishlist-page-container .view-button {
  background-color: #007bff;
  color: #fff;
  padding: 0.25rem 0.5rem;
  border: none;
  border-radius: 0.375rem;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.wishlist-page-container .view-button:hover {
  background-color: #0056b3;
}

/* Remove Button */
.wishlist-page-container .remove-button {
  background-color: #dc3545;
  color: #fff;
  padding: 0.25rem 0.5rem;
  border: none;
  border-radius: 0.375rem;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.wishlist-page-container .remove-button:hover {
  background-color: #bd2130;
}

@media (max-width: 991px) {
  .wishlist-page-title {
    font-size: 2.5rem;
  }

  .wishlist-table .product-name {
    font-size: 2.25rem;
  }

  .wishlist-table th,
  .wishlist-table .product-category,
  .wishlist-table .product-material {
    font-size: 2rem;
  }

  .wishlist-table span {
    font-size: 1.5rem;
  }

  .wishlist-table td:nth-child(3),
  .wishlist-table .view-button {
    font-size: 1.75rem;
    padding: 10px 35px;
  }

  .wishlist-table .product-actions {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .wishlist-table .product-actions .delete-button,
  .wishlist-table .product-actions .delete-button::before {
    transform: scale(1.4);
    margin-top: 5px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Components/styles/WishlistPage.css"],"names":[],"mappings":"AAAA,4BAA4B;AAC5B;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,wBAAwB;AACxB;EACE,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,mBAAmB;AACnB;EACE,YAAY;AACd;;AAEA,iBAAiB;AACjB;EACE,yBAAyB;EACzB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA,cAAc;AACd;EACE,6BAA6B;AAC/B;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA,mBAAmB;AACnB;EACE,cAAc;AAChB;;AAEA,iBAAiB;AACjB;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAiB;KAAjB,iBAAiB;AACnB;;AAEA,iBAAiB;AACjB;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA,qBAAqB;AACrB;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA,wBAAwB;AACxB;EACE,eAAe;EACf,eAAe;EACf,WAAW;AACb;;AAEA,qBAAqB;AACrB;EACE,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA,kBAAkB;AAClB;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,WAAW;AACb;;AAEA,gBAAgB;AAChB;EACE,yBAAyB;EACzB,WAAW;EACX,uBAAuB;EACvB,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,kBAAkB;AAClB;EACE,yBAAyB;EACzB,WAAW;EACX,uBAAuB;EACvB,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;;;IAGE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;;IAEE,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,mBAAmB;EACrB;;EAEA;;IAEE,qBAAqB;IACrB,eAAe;EACjB;AACF","sourcesContent":["/* Wishlist Page Container */\n.wishlist-page-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  margin-top: 5rem;\n}\n\n/* Wishlist Page Title */\n.wishlist-page-container .wishlist-page-title {\n  font-size: 2.5rem;\n  text-align: center;\n  color: #247a97;\n  margin-top: 4rem;\n  margin-bottom: 2rem;\n}\n\n/* Wishlist Table */\n.wishlist-page-container .wishlist-table {\n  width: 100vw;\n}\n\n/* Table Header */\n.wishlist-page-container .wishlist-table th {\n  background-color: #f2f2f2;\n  text-align: left;\n  padding: 0.5rem 1rem;\n}\n\n/* Table Row */\n.wishlist-page-container .wishlist-table tr {\n  border-bottom: 1px solid #ddd;\n}\n\n/* Product Info */\n.wishlist-page-container .product-info {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n}\n\n/* Product Avatar */\n.wishlist-page-container .product-avatar {\n  flex-shrink: 0;\n}\n\n/* Product Mask */\n.wishlist-page-container .product-mask {\n  width: 8rem;\n  height: 8rem;\n  overflow: hidden;\n  border-radius: 50%;\n}\n\n.wishlist-page-container .product-mask img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n/* Product Name */\n.wishlist-page-container .product-name {\n  font-size: 1.25rem;\n  font-weight: bold;\n}\n\n/* Product Material */\n.wishlist-page-container .product-material {\n  font-size: 0.875rem;\n  opacity: 0.7;\n}\n\n/* Product Description */\n.wishlist-page-container .product-description {\n  flex-wrap: wrap;\n  text-wrap: wrap;\n  width: 50vw;\n}\n\n/* Product Category */\n.wishlist-page-container .product-category {\n  font-size: 0.875rem;\n  opacity: 0.7;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n/* Product Price */\n.wishlist-page-container .product-price {\n  font-size: 1.25rem;\n  font-weight: bold;\n}\n\n/* Product Actions */\n.wishlist-page-container .product-actions {\n  display: flex;\n  gap: 0.5rem;\n}\n\n/* View Button */\n.wishlist-page-container .view-button {\n  background-color: #007bff;\n  color: #fff;\n  padding: 0.25rem 0.5rem;\n  border: none;\n  border-radius: 0.375rem;\n  cursor: pointer;\n  transition: background-color 0.3s ease;\n}\n\n.wishlist-page-container .view-button:hover {\n  background-color: #0056b3;\n}\n\n/* Remove Button */\n.wishlist-page-container .remove-button {\n  background-color: #dc3545;\n  color: #fff;\n  padding: 0.25rem 0.5rem;\n  border: none;\n  border-radius: 0.375rem;\n  cursor: pointer;\n  transition: background-color 0.3s ease;\n}\n\n.wishlist-page-container .remove-button:hover {\n  background-color: #bd2130;\n}\n\n@media (max-width: 991px) {\n  .wishlist-page-title {\n    font-size: 2.5rem;\n  }\n\n  .wishlist-table .product-name {\n    font-size: 2.25rem;\n  }\n\n  .wishlist-table th,\n  .wishlist-table .product-category,\n  .wishlist-table .product-material {\n    font-size: 2rem;\n  }\n\n  .wishlist-table span {\n    font-size: 1.5rem;\n  }\n\n  .wishlist-table td:nth-child(3),\n  .wishlist-table .view-button {\n    font-size: 1.75rem;\n    padding: 10px 35px;\n  }\n\n  .wishlist-table .product-actions {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n  }\n\n  .wishlist-table .product-actions .delete-button,\n  .wishlist-table .product-actions .delete-button::before {\n    transform: scale(1.4);\n    margin-top: 5px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
